$(document).ready(function() {
    $('.product-page--submit-action').click(function() {
        $('html').addClass('cart-drawer-open');
        $('.cart-charity-banner').show();
        $('.ajax-cart--bottom-wrapper').show();
      $('.free-shipping-bar').show();  
           $('.cart-empty-box').removeClass('hide');
    });
    $('.slide-menu-cart').click(function() {
        $('html').addClass('cart-drawer-open');
    });

    // $(".cart_product").slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     infinite: false,
    //     speed: 300,
    //     prevArrow: $('.prev-testimonial'),
    //     nextArrow: $('.next-testimonial'),
    //     responsive: [
    //         {
    //             breakpoint: 768,  
    //             settings: {
    //                 slidesToShow: 1
    //             }
    //         },
    //         {
    //             breakpoint: 480,  
    //             settings: {
    //                 slidesToShow: 1 
    //             }
    //         }
    //     ]
    // });


    //cart drawer free gift slider
    function initializeCartSlider1() {
        if (!$(".free-product .cart-drawer__recommendations-grid").hasClass("slick-initialized")) {
            $(".free-product .cart-drawer__recommendations-grid").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                speed: 300,
                prevArrow: $('#prev-free'),
                nextArrow: $('#next-free'),
                responsive: [
                    {
                        breakpoint: 768,  
                        settings: {
                            slidesToShow: 1
                        }
                    },
                    {
                        breakpoint: 480,  
                        settings: {
                            slidesToShow: 1 
                        }
                    }
                ]
            });
        } else {
            $(".free-product .cart-drawer__recommendations-grid").slick("refresh");
        }
    }
    function onCartDrawerOpen1() {
        setTimeout(function() {
            initializeCartSlider1();
        }, 100);
    }
    function monitorCartDrawer1() {  
        let cartDrawer = document.querySelector('.cart-drawer-right');
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if ($(cartDrawer).is(':visible')) {
                    onCartDrawerOpen1();
                }
            });
        });
        observer.observe(cartDrawer, { attributes: true, attributeFilter: ['style', 'class'] });
    }
    $(document).ready(function() {
        monitorCartDrawer1();
    });
    document.querySelector('.cart-drawer-right').addEventListener('open', function() {
        if ($('.free-product .cart-drawer__recommendations-grid').hasClass('slick-initialized')) {
            $('.free-product .cart-drawer__recommendations-grid').slick('setPosition'); 
        }
    });
    $(document).on('click', '.slide-menu-cart', function() {
        $('.cart-drawer-right').addClass('is-open');
        if ($('.free-product .cart-drawer__recommendations-grid').hasClass('slick-initialized')) {
            $('.free-product .cart-drawer__recommendations-grid').slick('setPosition');
        }
    });
    //cart drawer you may also like slider
    function initializeCartSlider() {
        if (!$(".like-product .cart-drawer__recommendations-grid").hasClass("slick-initialized")) {
            $(".like-product .cart-drawer__recommendations-grid").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                speed: 300,
                prevArrow: $('#prev-you-may-also-like'),
                nextArrow: $('#next-you-may-also-like'),
                responsive: [
                    {
                        breakpoint: 768,  
                        settings: {
                            slidesToShow: 1
                        }
                    },
                    {
                        breakpoint: 480,  
                        settings: {
                            slidesToShow: 1 
                        }
                    }
                ]
            });
        } else {
            $(".like-product .cart-drawer__recommendations-grid").slick("refresh");
        }
    }
    function onCartDrawerOpen() {
      
        setTimeout(function() {
            initializeCartSlider();
        }, 500);
    }
    function monitorCartDrawer() {  
        let cartDrawer = document.querySelector('.cart-drawer-right');
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if ($(cartDrawer).is(':visible')) {
                    onCartDrawerOpen();
                }
            });
        });
        observer.observe(cartDrawer, { attributes: true, attributeFilter: ['style', 'class'] });
    }
    $(document).ready(function() {
        monitorCartDrawer();
    });
    document.querySelector('.cart-drawer-right').addEventListener('open', function() {
        if ($('.like-product .cart-drawer__recommendations-grid').hasClass('slick-initialized')) {
            $('.like-product .cart-drawer__recommendations-grid').slick('setPosition'); 
        }
    });
    $(document).on('click', '.slide-menu-cart', function() {
        $('.cart-drawer-right').addClass('is-open');
        if ($('.like-product .cart-drawer__recommendations-grid').hasClass('slick-initialized')) {
            $('.like-product .cart-drawer__recommendations-grid').slick('setPosition');
        }
    });
    
 
    //benefit slider js
    $('.benefit-slider').slick({
        rows: 3,
        infinite: SVGComponentTransferFunctionElement,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('.prev-benefit'),
        nextArrow: $('.next-benefit'),
        responsive: [
            {
            breakpoint: 1199,
                settings: {
                slidesToShow: 1,
                }
            }
        ]
    });   
 

    //PDP add to cart
   
});

$(document).ready(function() {

    // $('.product-page--submit-action').on('click', function(event) {

    //     if ($(event.target).is('button')) {
    //         event.preventDefault(); 
           
    //         setTimeout(function() {
    //             fetchAndUpdateCart();
    //         }, 1000); 
    //    }
    // });
   

});

